import { appType } from "@/main"
import { Geetest } from 'vue3-geetest'
export default function useGeetest(app: appType) {
    app.use(Geetest, {
        captchaId: '5d880795f1d65adad5b3dc8cafd9e432'
    })
}